import { IPractice } from '@principle-theorem/principle-core/interfaces';
import {
  FactTables,
  reactivationHealthFundPatientsCampaignReportTemplate,
} from '@principle-theorem/reporting';
import { DocumentReference, Region } from '@principle-theorem/shared';
import { IMarketingCampaignTemplate } from './marketing-campaign-template';
import { getReactivationPatientsCampaignTemplate } from './reactivation-nz-campaign-template';

export function getReactivationHealthFundPatientsCampaignTemplate(
  practiceRef: DocumentReference<IPractice>
): IMarketingCampaignTemplate {
  const template = getReactivationPatientsCampaignTemplate(practiceRef);
  return {
    ...template,
    name: 'Reactivation Health Fund Patients (12-24 Months No Visit)',
    description: `A campaign targeting health fund patients who haven't visited in 12-24 months, encouraging them to book an appointment and maintain their oral health.`,
    regions: [Region.Australia],
    campaign: {
      ...template.campaign,
      name: 'Reactivation Health Fund Patients (12-24 Months No Visit)',
    },
    report: reactivationHealthFundPatientsCampaignReportTemplate(
      FactTables.patientEvent.latestEvent
    ),
  };
}
